<script>
export default {
    data() {
        return {
            maxHeight: 250,
            otherUiTotalHeight: 235,
        };
    },
    mounted() {
        window.addEventListener('resize', this.updateTableHeight);
        this.$nextTick(() => {
            this.updateTableHeight();
        });
    },
    destroyed() {
        window.removeEventListener('resize', this.updateTableHeight);
    },
    methods: {
        updateTableHeight() {
            const winHeight = window.innerHeight;
            this.maxHeight = winHeight - this.otherUiTotalHeight;
        },
    },
};
</script>
<style lang="scss">
.accounting-summary-table {
    font-size: 10pt;
    border-color: #dfe2e5;

    .el-table__body-wrapper {
        height: 100%;
    }

    &.el-table th {
        padding: 5px 0 !important;
        background-color: #f7f7f7;
        font-size: 9.5pt;
        font-weight: normal;
        color: #555;
        // border-top: 1px solid #ccc;
        border-color: #dfe2e5;
    }

    &.el-table td {
        padding: 6px 0 !important;
        border-color: #dfe2e5;
        color: #666;

        &.blue {
            background-color: #f1f4ff;
        }
        &.yellow {
            background-color: #fffde7;
        }
        &.red {
            background-color: #fff5f5;
        }
        &.strong {
            color: #000;
        }
    }

    .el-table__row {
        cursor: pointer;

        &.hover-row {
            td {
                &.blue {
                    background-color: #e0e5f8;
                }
                &.yellow {
                    background-color: #fbf8da;
                }
                &.red {
                    background-color: #fae9e9;
                }
            }
        }
    }

    .blur-zero {
        color: #ccc;
    }
}

</style>
